import { FC, useContext } from 'react';
import { BCMs } from '../../../../../../Components/Forms/Schedule/BCMs';
import { CompanyDashboardContext } from '../../../../Utils';

export const CompanyDashboardBCMTab: FC = () => {
    const { company, searchText } = useContext(CompanyDashboardContext);

    return <BCMs company={company} searchText={searchText} />;
};